import { track } from './analytics'
import { clearFestivalScheduleFilter } from './scheduleFilterSession'

const STORAGE_KEY = 'beacon_live_festival_route'

interface SavedRoute {
  path: string
  eventEndDate: string
}

export function saveFestivalRoute(path: string, eventEndDate: string) {
  try { localStorage.setItem(STORAGE_KEY, JSON.stringify({ path, eventEndDate })) } catch { /* quota */ }
}

export function clearFestivalRoute() {
  try { localStorage.removeItem(STORAGE_KEY) } catch { /* noop */ }
  clearFestivalScheduleFilter()
}

// Returns the saved festival-mode path if it exists and the event hasn't ended
// more than 24 hours ago. Clears stale/invalid entries automatically.
export function getSavedFestivalRoute(): string | null {
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    if (!raw) return null

    const saved: SavedRoute = JSON.parse(raw)
    if (!saved.path?.startsWith('/live-festival/')) {
      clearFestivalRoute()
      return null
    }

    const endMs = new Date(saved.eventEndDate + 'T23:59:59').getTime()
    if (Date.now() > endMs + 24 * 60 * 60 * 1000) {
      const eventId = saved.path.split('/')[2]
      if (eventId) track('festival_mode_expired', { event_id: eventId })
      clearFestivalRoute()
      return null
    }

    return saved.path
  } catch {
    clearFestivalRoute()
    return null
  }
}
